import { readIsInFreeSubscription } from '@hub/lib/subscription/readSubscription';
import type { RouterContext } from '@hub/router';
import { redirect } from '@hub/router/domain-routes';
import { track } from '@platform/tracking';
import { BirthdayContestPaths } from '../route.paths';
import { birthdayContestDestination, resolveBirthdayContestOutcome } from './destinations';

interface LoadBirthdayContestDestinationArgs {
  context: RouterContext;
  deps: { marker: 'confirm-email' | undefined };
}

/**
 * The virtual page's entire behavior: decide a destination, then leave. Authentication is enforced
 * by the route's own `beforeLoad` (`requireAuthentication`), so by the time this runs the visitor is
 * authenticated. Their subscription is only read when there's no arrival marker to settle it
 * outright, so a just-confirmed registrant never waits on a subscription fetch that wouldn't change
 * the answer.
 */
export async function loadBirthdayContestDestination({ context, deps }: LoadBirthdayContestDestinationArgs): Promise<never> {
  const isInFreeSubscription = deps.marker === undefined ? await readIsInFreeSubscription(context.queryClient) : undefined;
  const outcome = resolveBirthdayContestOutcome(deps.marker, isInFreeSubscription);

  // `page` given explicitly rather than left to `trackBeforeNav`'s `window.location.pathname`: the
  // live URL is localized, which would split one campaign's calls across two page values.
  track('birthday_contest_redirected', { outcome }, { page: BirthdayContestPaths.landing.path });

  throw redirect({ href: birthdayContestDestination(outcome), reloadDocument: true, replace: true });
}
